import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import {IconButton, Tooltip} from "@mui/material";
import {formatDateTime} from "crqlar-react-common/dist/utils/date.util";
import {useTranslation} from "react-i18next";
import {DigitalSigningStatusView} from "../digitalSigning.model";

interface Props {
    /** Signed or confirmed: the tooltip says when. */
    signing: DigitalSigningStatusView
    /** Shows what the guest signed. */
    onClick: () => void
    /** Medium beside a footer's buttons; small in a table row, or beside a page header's text buttons. */
    size?: 'small' | 'medium'
}

/**
 * The green icon of what the guest signed, from the signature on - still to confirm, or confirmed:
 * after ⋮ in the reservation dialog's and the folio view's footers, after a folio's name in the folio
 * list, before Print in the reservation page's header. Staff check the signature with it before they
 * confirm; a click shows what the guest signed.
 */
const DigitalSigningSignatureButton = ({signing, onClick, size = 'medium'}: Props) => {
    const {t} = useTranslation();
    // The same icon either way: the folio's status tells a confirmed one apart, and the tooltip
    const when = signing.status === 'CONFIRMED'
        ? t('Confirmed on {{date}}', {date: formatDateTime('dd.MM.yyyy HH:mm', signing.confirmedAt)})
        : t('Signed on {{date}}', {date: formatDateTime('dd.MM.yyyy HH:mm', signing.signedAt)});

    return (
        <Tooltip title={when}>
            <IconButton aria-label={t('Show signature')} size={size} onClick={onClick} sx={{color: 'success.main'}}>
                <FactCheckOutlinedIcon fontSize={size}/>
            </IconButton>
        </Tooltip>
    );
};

export default DigitalSigningSignatureButton;
